import { useCallback } from 'react';
import { memoize } from 'lodash-es';
import { asyncAttempt } from '@namespace/helpers';
import { parseCnp } from '../../utils';

const parseCnpMemed = memoize(parseCnp);

export const useParsePin = () => {
  const handleParse = useCallback(async (value) => {
    const [err, response] = await asyncAttempt(parseCnpMemed, value);

    const hasError = err || !response;
    const data = hasError ? null : { ...response, pin: value };

    return data;
  }, []);

  return { run: handleParse };
};
